import {FunctionComponent} from 'react';

export const VerticalSeparator: FunctionComponent<{my?: `my-${number}`}> = ({my = 'my-3'}) => (
  <div className={`h-px w-full bg-white opacity-20 ${my}`} />
);
